export enum FilterType {
    Firmware = 'Firmware',
    Location = 'Location',
    Manufacturer = 'Manufacturer',
    Model = 'Model',
    TestsStatus = 'TestsStatus',
};